<template>
  <section class="section products-intro">
    <Container>
      <div class="intro-card" data-reveal>
        <div class="intro-content">
          <p class="eyebrow">Shop Deyoke Foods</p>
          <h1>Turkey Berry Products, Crafted for Everyday Wellness</h1>
          <p class="lead">
            Shipped across Ghana and beyond — from our farms straight to your
            kitchen, packed with the nutrients your body needs.
          </p>
          <ul class="benefit-chips">
            <li v-for="benefit in benefits" :key="benefit">{{ benefit }}</li>
          </ul>
        </div>
        <div class="intro-image">
          <img src="@/assets/product.png" alt="Turkey Berry Product" />
        </div>
      </div>
    </Container>
  </section>
</template>

<script setup>
import Container from "@/components/Container/Container.vue"

const benefits = ["Proteins", "Fibres", "Vitamins A & C", "Minerals", "Antioxidants", "Carbohydrates"]
</script>

<style scoped>
.products-intro {
  padding-top: 0;
}

.intro-card {
  background: linear-gradient(135deg, var(--primary-800) 0%, var(--primary) 100%);
  border-radius: var(--radius-lg);
  padding: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3rem;
  overflow: hidden;
  position: relative;
}

.intro-content {
  max-width: 520px;
  position: relative;
  z-index: 1;
}

.intro-content .eyebrow {
  color: var(--accent);
}

.intro-content .eyebrow::before {
  background: var(--accent);
}

.intro-content h1 {
  color: #fff;
  font-size: clamp(1.9rem, 3.4vw, 2.6rem);
  font-weight: 800;
  line-height: 1.2;
}

.intro-content .lead {
  margin-top: 1rem;
  color: rgba(255, 255, 255, 0.78);
  font-size: 1rem;
  line-height: 1.7;
}

.benefit-chips {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 1.75rem;
}

.benefit-chips li {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: #fff;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: var(--radius-pill);
}

.intro-image {
  flex-shrink: 0;
  width: clamp(220px, 26vw, 320px);
  position: relative;
  z-index: 1;
}

.intro-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 24px 30px rgba(0, 0, 0, 0.35));
}

@media (max-width: 1023px) {
  .intro-card {
    flex-direction: column;
    text-align: center;
    padding: 2.75rem 2rem;
  }

  .intro-content {
    max-width: 100%;
  }

  .benefit-chips {
    justify-content: center;
  }

  .intro-image {
    width: 200px;
  }
}
</style>
